import { render, staticRenderFns } from "./VariantsTab.vue?vue&type=template&id=10ff3003&"
import script from "./VariantsTab.vue?vue&type=script&lang=ts&"
export * from "./VariantsTab.vue?vue&type=script&lang=ts&"
import style0 from "./VariantsTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports